import React from "react";
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Home from "./pages/index";
import Login from "./pages/login";
import Register from "./pages/register";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import FAQs from "./pages/frequently-asked-questions";
import Dashboard from "./pages/dashboard"
import Admin from "./pages/admin"
import Pagenotfound from "./pages/404";
import Support from "./pages/support";
import Terms from "./pages/terms-of-service";
import PrivacyPolicy from "./pages/privacy-policy";
import Demo from "./pages/demo";
import Blog from "./pages/blog";
import BlogPost from "./pages/blog-post";
import ShopHome from "./pages/shop";
import ShopCategory from "./pages/shop-category";
import ShopBusiness from "./pages/shop-business";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "MiAmigo.AI",
  "url": "https://miamigo.ai",
  "logo": "https://miamigo.ai/android-chrome-512x512.png",
  "description": "AI chatbot that answers customer questions using your own website content, installable on any site in minutes.",
  "email": "support@miamigo.ai",
}

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "MiAmigo.AI",
  "url": "https://miamigo.ai",
}

function App() {

  return (
    <HelmetProvider>
      <Router>
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
          <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
        </Helmet>
        <NavBar />
        <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/frequently-asked-questions" component={FAQs} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/admin-miamigo" component={Admin} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/terms-of-service" component={Terms} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/demo/:userid" component={Demo} />
        <Route exact path="/blog" component={Blog} />
        <Route exact path="/blog/:slug" component={BlogPost} />
        <Route exact path="/ask" component={ShopHome} />
        <Route exact path="/places/:category" component={ShopCategory} />
        <Route exact path="/places/:category/:slug" component={ShopBusiness} />
        <Redirect exact from="/shop" to="/ask" />
        <Redirect exact from="/discover" to="/ask" />
        <Redirect exact from="/shop/:category" to="/places/:category" />
        <Redirect exact from="/shop/:category/:slug" to="/places/:category/:slug" />
        <Route exact path="/404" component={Pagenotfound} />
        <Redirect from="*" to="/404" />
      </Switch>
      <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
